import _objectSpread from "/usr/app/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import React from "react";
var __jsx = React.createElement;
import { useEffect } from "react";
import PaymentSuccess from "@/pages/checkout/pay-success/PaymentSuccess/PaymentSuccess";
import queryString from "query-string";
import Layout from "@/_LayoutsRelated/layout/Layout";
import { useLocation } from "react-router-dom";
import { trackEvents } from "@/common/events/events";
import { useSession } from "@/_MiniApps/auth/AuthContext";
import useSubmissionSource from "@hooks/useSubmissionSource";
import { useCheckoutOrder } from "@/common/Contexts/CheckoutOrderContext";
import useWebview from "@hooks/useWebview";
import useIsWebView from "@hooks/useIsWebview";
import { useEnhancedPromoSystem } from "@/_MiniApps/customized_promo_codes/hooks/useEnhancedPromoSystem";
var CheckoutSuccess = function CheckoutSuccess() {
  var checkoutOrder = useCheckoutOrder().state.checkoutOrder;
  var order_id = useCheckoutOrder().queryParams.order_id;
  var fetch__getOrderWithPaymentInfo = useCheckoutOrder().remote_actions.fetch__getOrderWithPaymentInfo;
  var location = useLocation();
  var _useSession = useSession(),
    user = _useSession.user;
  var webview = useWebview();
  var isWebview = useIsWebView();
  var _useSubmissionSource = useSubmissionSource(),
    getSubmissionSource = _useSubmissionSource.getSubmissionSource;
  var _useEnhancedPromoSyst = useEnhancedPromoSystem(),
    getPromoEventParams = _useEnhancedPromoSyst.getPromoEventParams,
    promoCode = _useEnhancedPromoSyst.promoCode,
    getPromoCodeDataForTracking = _useEnhancedPromoSyst.getPromoCodeDataForTracking;
  useEffect(function () {
    webview.setBackButtonScreen("post_details")["catch"](function () {
      // please keep the catch
    });
    if (!order_id) return;
    fetch__getOrderWithPaymentInfo(null, order_id);
  }, [order_id]);
  useEffect(function () {
    var _checkoutOrder$g4_dat;
    if (!checkoutOrder) return;
    var search = location.search;
    var values = queryString.parse(search);
    var submission_source = getSubmissionSource();
    var eventPayload = _objectSpread(_objectSpread(_objectSpread({}, checkoutOrder === null || checkoutOrder === void 0 ? void 0 : checkoutOrder.g4_data_layer), {}, {
      post_trim: checkoutOrder.g4_data_layer.post_ext,
      order_id: checkoutOrder.id.toString()
    }, checkoutOrder.payment_type && {
      payment_option: checkoutOrder.payment_type
    }), {}, {
      response_code: checkoutOrder.response_code || null,
      payment_status: "Success",
      response_message: checkoutOrder.response_message || null,
      inventory_type_string: (checkoutOrder === null || checkoutOrder === void 0 ? void 0 : (_checkoutOrder$g4_dat = checkoutOrder.g4_data_layer) === null || _checkoutOrder$g4_dat === void 0 ? void 0 : _checkoutOrder$g4_dat.inventory_type_string) || null,
      total_amount: parseFloat(checkoutOrder.payed_amount.replace(/,/g, "")) || null,
      discount_code: (checkoutOrder === null || checkoutOrder === void 0 ? void 0 : checkoutOrder.referral_code) || null,
      referral_location: submission_source
    });
    console.log("eventPayload.discount_code", eventPayload.discount_code);
    console.log("promoCode?.code", promoCode === null || promoCode === void 0 ? void 0 : promoCode.code);
    var promoData = promoCode !== null && promoCode !== void 0 && promoCode.code ? promoCode : getPromoCodeDataForTracking();
    var promoCodeData = getPromoEventParams(!eventPayload.discount_code || (eventPayload === null || eventPayload === void 0 ? void 0 : eventPayload.discount_code) !== (promoData === null || promoData === void 0 ? void 0 : promoData.code));
    console.log("promoCodeData", promoCodeData);
    trackEvents("cash_order_submit", _objectSpread(_objectSpread({}, eventPayload), promoCodeData));
  }, [checkoutOrder === null || checkoutOrder === void 0 ? void 0 : checkoutOrder.id]);

  //if (fetch_loading) return <Loader/>;

  return /*#__PURE__*/React.createElement(Layout, {
    hideFooter: true,
    headHideLinks: true,
    hideAppBanner: true,
    disableLoader: true
  }, /*#__PURE__*/React.createElement("div", {
    className: isWebview ? "mt-4" : ""
  }, "   ", /*#__PURE__*/React.createElement(PaymentSuccess, {
    checkoutOrder: checkoutOrder
  })));
};
export default CheckoutSuccess;